/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Course } from '../../models/course';
import { CourseApiRespModel } from '../../models/course-api-resp-model';

export interface ApiMasterCourseAddPost$Params {
      body?: Course
}

export function apiMasterCourseAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterCourseAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseApiRespModel>;
    })
  );
}

apiMasterCourseAddPost.PATH = '/api/Master/Course/Add';
